!(function () {
  function e() {
    subSliderInit(!0), sliderInit(!0), popupSliderInit(!0);
  }
  function i(e, t) {
    var o = e.clientHeight;
    (e.style.transitionProperty = 'height, margin, padding'),
      (e.style.transitionDuration = t + 'ms'),
      (e.style.boxSizing = 'border-box'),
      (e.style.overflow = 'hidden'),
      (e.style.height = o + 'px'),
      (e.style.paddingTop = '0'),
      (e.style.paddingBottom = '0'),
      (e.style.marginTop = '0'),
      (e.style.marginBottom = '0'),
      setTimeout(function () {
        (e.style.height = '0'),
          (e.style.paddingTop = '0'),
          (e.style.paddingBottom = '0'),
          (e.style.marginTop = '0'),
          (e.style.marginBottom = '0');
      }, 10),
      setTimeout(function () {
        (e.style.display = 'none'),
          e.style.removeProperty('height'),
          e.style.removeProperty('padding-top'),
          e.style.removeProperty('padding-bottom'),
          e.style.removeProperty('margin-top'),
          e.style.removeProperty('margin-bottom'),
          e.style.removeProperty('overflow'),
          e.style.removeProperty('transition-duration'),
          e.style.removeProperty('transition-property');
      }, t);
  }
  const t = () => {
      document.querySelectorAll('.about__accordion-toggle').forEach((r) => {
        r.addEventListener('click', () => {
          if (
            (document
              .querySelectorAll(
                '.product__info-container .about__accordion-toggle'
              )
              .forEach((e) => {
                e != r && e.classList.remove('active');
              }),
            document
              .querySelectorAll(
                '.product__info-container .about__accordion-toggle'
              )
              .forEach((e) => {
                e != r && i(e.nextElementSibling, 300);
              }),
            r.classList.contains('active'))
          )
            r.classList.remove('active'), i(r.nextElementSibling, 300);
          else {
            r.classList.add('active');
            {
              var e = r.nextElementSibling,
                t = 300;
              (e.style.overflow = 'hidden'),
                (e.style.height = '0'),
                (e.style.display = 'block');
              const o = e.scrollHeight;
              setTimeout(function () {
                e.style.height = o + 'px';
              }, 10),
                setTimeout(function () {
                  e.style.removeProperty('overflow'),
                    e.style.removeProperty('height');
                }, t);
            }
          }
        });
      });
    },
    o = () => {
      const e = document.querySelector(
        '.main-product .product-form__submit-wrapper'
      );
      if (e) {
        let t = !0,
          o = !1;
        const i = () => {
          t || o
            ? (e.closest('.product-form__buttons-row').removeAttribute('style'),
              e.classList.remove('fixed'))
            : e.classList.contains('fixed') ||
              ((e.closest('.product-form__buttons-row').style.minHeight =
                e.clientHeight + 'px')
            );
        };
        new IntersectionObserver(
          (e) => {
            var [e] = e;
            (t = e.isIntersecting),
              i(),
              console.log('from buttonObserver', t, o);
          },
          { root: null, rootMargin: '0px 0px 45px 0px', threshold: 0.01 }
        ).observe(document.querySelector('.product-form__buttons'));
        var r = new IntersectionObserver(
          (e) => {
            var [e] = e;
            (o = e.isIntersecting),
              i(),
              console.log('from footerObserver', t, o);
          },
          { root: null, rootMargin: '0px', threshold: 0.01 }
        );
        document.querySelector('.footer') &&
          r.observe(document.querySelector('.footer'));
      }
    };
  class r extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide(), window.pauseAllMedia();
    }
    show(e) {
      super.show(e), this.showActiveMedia();
    }
    showActiveMedia() {
      var e = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
      );
      'DEFERRED-MEDIA' == e.nodeName &&
        e.querySelector('template')?.content?.querySelector('.js-youtube') &&
        e.loadContent();
    }
  }
  if (!window.customElements.get("product-modal")) {
    customElements.define('product-modal', r),
    document.addEventListener('shopify:section:load', function () {
      t(), o(), e();
    }),
    e(),
    t(),
    o();
  }
})();

async function getVariantIdFromOptions(productHandle) {
  // Fetch product data
  const response = await fetch(`/products/${productHandle}.js`);
  const product = await response.json();
  // Get selected options and clean them
  const optionSelects = document.querySelectorAll('.select__select');
  const selectedOptions = Array.from(optionSelects).map(select => {
    const rawValue = select.value;
    return rawValue.includes('- Unavailable') 
      ? rawValue.replace('- Unavailable', '').trim()
      : rawValue;
  });
  // Find matching variant (also cleaning variant options)
  const matchedVariant = product.variants.find(variant => {
    return variant.options.every((variantOption, index) => {
      const cleanVariantOption = variantOption?.includes('- Unavailable')
        ? variantOption.replace('- Unavailable', '').trim()
        : variantOption;
      
      const cleanSelectedOption = selectedOptions[index]?.includes('- Unavailable')
        ? selectedOptions[index].replace('- Unavailable', '').trim()
        : selectedOptions[index];
      
      return cleanVariantOption === cleanSelectedOption;
    });
  });
  return matchedVariant?.id;
}

function updateProductTags() {
  var url = window.location.pathname;
  const productHandle = window.location.pathname.split('/products/')[1];
  if (productHandle) {
    getVariantIdFromOptions(productHandle).then(variantId => {
      if (variantId) {
        url = `${window.location.pathname}?variant=${variantId}`;
        // Setting correct variant ID in the form input value 
        let formInputVal = document.querySelector('.product-form form [name="id"]');
        formInputVal.value = variantId;
      } else {
        url = `${window.location.pathname}`;
      }
      window.history.replaceState({}, '', url);
      const tagsContainer = $('.product__info-container .card__tags');
      const tagWrapper = $('.product__info-container .tag__wrapper');

      if (!tagsContainer.length && tagWrapper.length) {
        $('<ul>', {
          class: 'card__tags flex flex-wrap gap-sm-xs flex md:flex pointer-events-none select-none w-full justify-center md-justify-center'
        }).appendTo(tagWrapper);
      }

      $.get(url, function(data) {
        var pageContent = $(data).find('.product__info-container .card__tags').html();
        pageContent = pageContent?.replace(/\s*<\s*/g, '<').replace(/\s*>\s*/g, '>').replace(/>\s+</g, '><').trim();
        if (!pageContent?.trim()) {
          $('.product__info-container .card__tags').html('');
        } else {
          $('.product__info-container .card__tags').html(pageContent);
        }
      });
    });
  }
}

function setTagsPurchaseLimitContent() {
  // Setting product tags content on variant change
  setTimeout(updateProductTags, 50);
  // Hide purchase limit error message on variant change
  const purchaseLimitErrorWrapper = document.querySelector('.product-form__error-message-wrapper');
  if (purchaseLimitErrorWrapper && !purchaseLimitErrorWrapper.hasAttribute('hidden')) {
    purchaseLimitErrorWrapper.setAttribute('hidden', 'true');
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const variantSelects = document.querySelectorAll('.product__info-container .select__select');
  // Attach event to all variant dropdowns
  variantSelects.forEach((dropdown) => {
    dropdown.addEventListener('change', function() {
      setTagsPurchaseLimitContent();
    });
  });
  setTagsPurchaseLimitContent();
});